import React, { useState } from "react";
import { toast } from "react-toastify";
import Table from "../../../../components/elements/table/Table";
import { setTitle } from "../../../../helpers/MetaTag";
import { handleFilterChange } from "../../../../helpers";
import DeleteModal from "../../../../components/common/DeleteModal";
import { useDebounce } from "../../../../hooks/useDebounce";
import LimitSelect from "../../../../components/elements/LimitSelect";

// import { useGetPermission } from "../../hooks/useGetPermission";
import Search from "../../../../components/form/Search";
import Button from "../../../../components/form/Button";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { transactionDelete, transactionList } from "../../../../services/transactionService";
import dayjs from "dayjs";
import ManageTransactionDrawer from "../../../../components/sections/admin/Transaction/Drawer/ManageTransactionDrawer";
import Badge from "../../../../components/elements/Badge";
import { PAYMENT_METHOD, PAYMENT_STATUS } from "../../../../components/constant/constant";
import PaymentMethod from "../../../../components/common/PaymentMethod";
import { postStatusChange } from "../../../../services/postService";

const Transaction = ({ isSubscriptionDetails = false, subscriptionId = null,userId=null }) => {
  setTitle("Orders");

  const [selectedItems, setSelectedItems] = useState([]);
  const [modalOpen, setModalOpen] = useState({ isOpen: false, data: null });
  const [keyword, setKeyword] = useState("");
  const search = useDebounce(keyword, 300);
  const queryClient = useQueryClient();
  const [deleteModal, setDeleteModal] = useState({
    isOpen: false,
    data: null,
  });
  const [filters, setFilters] = useState({
    limit: 10,
    page: 1,
    sortQuery: "ordering",
  });

  const { data, isLoading, updateData, isFetching } = useQuery({
    queryKey: ["transaction", filters, search, subscriptionId,userId],
    queryFn: async () => {
      const res = await transactionList({
        ...filters,
        ...(search && { keyword: search }),
        ...(subscriptionId && { subscriptionId: subscriptionId }),
        ...(userId && { userId: userId }),
      });
      if (res?.status !== 200) {
        toast.warning(res?.message);
      }
      return res?.docs;
    },
  });

  const tableHeadData = [
    {
      _id: 2,
      name: "Name",
      align: "left",
    },
    {
      _id: 3,
      name: "Email",
      align: "left",
    },
    {
      _id: 4,
      name: "Fiat",
      align: "left",
    },
    {
      _id: 4,
      name: "Crypto",
      align: "left",
    },
    {
      _id: 5,
      name: "Amount",
      align: "left",
    },
    {
      _id: 9,
      name: "Date",
      align: "left",
    },
    {
      _id: 10,
      name: "Payment Method",
      align: "left",
    },
    {
      _id: 11,
      name: "Payment Status",
      align: "left",
    },
    {
      _id: 13,
      name: "Action",
      align: "left",
    },
  ];

  // Table Body Data =====================>
  const tableData = data?.data?.map((item) => {
    return {
      _id: item?._id,
      rowData: [
        {
          _id: 2,
          type: "user",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.userData?.firstName + " " + item?.userData?.lastName || "-",
          image: item?.userData?.image?.url,
        },
        {
          _id: 3,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.userData?.email || "-",
        },
        {
          _id: 4,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data:
            (
              <div className="flex flex-col">
                <span className="flex items-center gap-1 font-semibold text-gray-900">
                  {item?.fiatAmount.toFixed(2)}
                  <span className="px-1 py-0.5 bg-gray-200 text-gray-700 text-xs rounded">{item?.fiatCurrency}</span>
                </span>
              </div>
            ) || "-",
        },
        {
          _id: 5,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data:
            (
              <div className="flex flex-col">
                <span className="flex items-center gap-1 text-gray-600 text-sm">
                  {item?.cryptoAmount.toFixed(2)}
                  <span className="px-1 py-0.5 bg-gray-200 text-gray-700 text-xs rounded">{item?.cryptoCurrency}</span>
                </span>
              </div>
            ) || "-",
        },
        {
          _id: 6,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: "$" + "" + item?.totalPayable || "-",
        },
        {
          _id: 9,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.createdAt ? dayjs(item?.createdAt).format("DD MMM, YYYY") : "-",
        },
        {
          _id: 10,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: <PaymentMethod type={item?.paymentMethod} />,
        },
        {
          _id: 11,
          type: "text",
          align: "left",
          cellClass: "!min-w-[50px]",
          data: (
            <Badge
              customColor={PAYMENT_STATUS[item?.paymentGateway?.status]?.class || ""}
              label={PAYMENT_STATUS[item?.paymentGateway?.status]?.label || "-"}
              className="!rounded-full !h-6 !max-w-auto"
            />
          ),
        },
        {
          _id: 12,
          type: "action",
          align: "left",
          cellClass: "w-[5%]",
          actionData: [
            // {
            //   _id: 1,
            //   name: "Edit",
            //   icon: "fa-regular fa-pen-to-square",
            //   onClick: () => {
            //     setModalOpen({ isOpen: true, data: item });
            //   },
            // },
            // {
            //   _id: 2,
            //   name: "Download Receipt",
            //   icon: "fa-regular fa-download",
            //   onClick: () => {
            //     handleDownloadReceipt(item);
            //     // navigate(`/admin/donations/pdf`, {
            //     //   state: {
            //     //     data: item,
            //     //     type: "DonationReciptPdf",
            //     //     fileName: `Receipt-${item?.invoiceId || "N/A"}.pdf`,
            //     //   },
            //     // });
            //   },
            // },
            // {
            //   _id: 3,
            //   name: "Add Transaction",
            //   icon: "fa-regular fa-hand-holding-circle-dollar",
            //   onClick: () => {
            //     setModalOpen({ isOpen: true, data: item });
            //   },
            // },
            {
              _id: 4,
              name: "Delete",
              icon: "fa-regular fa-trash-can",
              standout: true,
              onClick: () => {
                setDeleteModal({
                  isOpen: true,
                  data: item,
                });
              },
            },
          ],
        },
      ],
    };
  });

  // add or edit FAQ =================>
  function faqManageResponse(res) {
    if (res?.status === 200 || res?.status === 201) {
      if (res?.status === 201) {
        if (filters?.page === 1) {
          queryClient.setQueryData(["transaction", filters, search], (state) => {
            if (state) {
              let stateData = JSON.parse(JSON.stringify(state?.data));
              stateData = [...stateData, res?.data];
              return { ...state, data: stateData };
            }
          });
          if (data?.metadata?.totalDocs > filters?.limit) {
            queryClient.invalidateQueries(["transaction", filters, search]);
          }
        } else {
          setFilters((pre) => ({ ...pre, page: 1 }));
        }
      }
      if (res?.status === 200) {
        queryClient.setQueryData(["transaction", filters, search], (state) => {
          if (state) {
            let stateData = JSON.parse(JSON.stringify(state?.data));
            stateData = stateData?.map((item) => (item?._id === res?.data?._id ? { ...item, ...res?.data } : item));
            return { ...state, data: stateData };
          }
        });
        if (data?.metadata?.totalDocs > filters?.limit) {
          queryClient.invalidateQueries(["transaction", filters, search]);
        }
      }
      setModalOpen({ isOpen: false, data: null });
    } else {
      toast.warning(res?.message || res?.error);
    }
  }

  //   FAQ delete handler =================>
  const { mutate: deleteHandler, isPending: deletePending } = useMutation({
    mutationFn: async (payload) => {
      const res = await transactionDelete({
        ids: Array.isArray(payload) ? payload : [payload],
      });
      return { res, payload: Array.isArray(payload) ? payload : [payload] };
    },
    onSuccess: ({ res, payload }) => {
      if (res?.status === 200) {
        setDeleteModal({ isOpen: false, data: null });
        setSelectedItems([]);
        queryClient.setQueryData(["transaction", filters, search], (state) => {
          if (state) {
            let stateData = JSON.parse(JSON.stringify(state?.data));
            stateData = (stateData || [])?.filter((item) => !payload?.includes(item?._id));
            return { ...state, data: stateData };
          }
        });

        if (data?.metadata?.totalDocs > filters?.limit) {
          queryClient.invalidateQueries(["transaction", filters, search]);
        }
      } else {
        toast.warning(res?.message || res?.error);
      }
    },
    onError: (error) => {
      console.log(error);
    },
  });

  return (
    <div className="space-y-4 w-full flex flex-col pb-10">
      <div className="space-y-8">
        {!userId ? (
          <div className="font-bold text-lg xl:text-3xl text-primary">Order Management</div>
        ) : (
          <div className="font-bold text-xl text-salte-500">All Orders</div>
        )}

        <div className="flex items-center gap-3">
          <div className="w-36">
            <LimitSelect
              value={filters?.limit}
              allValue={data?.metadata?.totalDocs}
              onChange={(val) => handleFilterChange("limit", val, setFilters)}
            />
          </div>
          <div className="w-72">
            <Search
              placeholder={"Search here"}
              search={(val) => {
                setKeyword(val);
                handleFilterChange("page", 1, setFilters);
              }}
            />
          </div>
          {/* <div className="relative">
            <Button
              buttonClasses={
                "!bg-transparent border border-transparent !h-10 hover:!bg-primary/10 hover:!border-primary/10"
              }
              buttonLabel={"Create New"}
              buttonLabelClasses={"font-medium !text-sm text-primary"}
              buttonFunction={() => setModalOpen({ isOpen: true, data: null })}
            />
          </div> */}
        </div>
      </div>

      <Table
        tableHeadData={tableHeadData}
        tableData={tableData}
        isLoder={isLoading}
        pageCount={data?.metadata?.totalPages}
        currentPage={filters?.page}
        onPageChange={(val) => {
          handleFilterChange("page", val, setFilters);
          setSelectedItems([]);
        }}
        isFetching={isFetching}
        selectedItems={selectedItems}
        setSelectedItems={setSelectedItems}
        tableActionDropdownContainer={"!w-48"}
      />

      <ManageTransactionDrawer
        open={modalOpen?.isOpen}
        data={modalOpen?.data}
        close={() => setModalOpen({ isOpen: false, data: null })}
        getResponse={faqManageResponse}
      />
      <DeleteModal
        open={deleteModal?.isOpen}
        loading={deletePending}
        onClose={() => setDeleteModal((pre) => ({ data: null, isOpen: false }))}
        deleteHandler={() => {
          deleteHandler(deleteModal?.data?._id);
        }}
      />
    </div>
  );
};

export default Transaction;
